import { FC } from 'react'
import { Outlet } from 'react-router-dom'

// ROUTES
import { EditPledgeContributionRoute } from './contribution'

// TYPES
import type { RouteObject } from 'react-router-dom'


const Component: FC<{}> = () => {
    return <Outlet />
}

const PledgeIdRoute: RouteObject = {
    path: ':pledgeId',
    Component,
    children: [
        EditPledgeContributionRoute,
    ]
}

export { PledgeIdRoute }